"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const cgui_core_atoms_button_1 = require("@campgladiator/cgui-core.atoms.button");
const cgui_core_atoms_card_1 = require("@campgladiator/cgui-core.atoms.card");
const cgui_core_atoms_icon_1 = require("@campgladiator/cgui-core.atoms.icon");
const cgui_core_atoms_typography_1 = require("@campgladiator/cgui-core.atoms.typography");
const growl_message_module_scss_1 = __importDefault(require("./growl-message.module.scss"));
const GrowlMessage = ({ autoClose = true, button = {
    onClick: () => { },
    text: "",
}, children, isVisible, onClick, title = "", }) => {
    autoClose &&
        setTimeout(() => {
            isVisible && onClick();
        }, 6000);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(cgui_core_atoms_card_1.Card, { className: (0, classnames_1.default)(growl_message_module_scss_1.default.growlMessage, {
                [growl_message_module_scss_1.default.open]: isVisible,
            }) },
            react_1.default.createElement("div", { className: growl_message_module_scss_1.default.content },
                title && (react_1.default.createElement(cgui_core_atoms_typography_1.Paragraph, { size: "small", weight: "bold", className: growl_message_module_scss_1.default.title }, title)),
                react_1.default.createElement(cgui_core_atoms_typography_1.Paragraph, { size: "small", weight: "book", className: growl_message_module_scss_1.default.description }, children)),
            button.text && (react_1.default.createElement("div", { className: growl_message_module_scss_1.default.action },
                react_1.default.createElement(cgui_core_atoms_button_1.Button, { onClick: button.onClick, size: "small", variation: "outline", emphasis: "negative" }, button.text))),
            react_1.default.createElement("div", { className: growl_message_module_scss_1.default.close },
                react_1.default.createElement(cgui_core_atoms_icon_1.Icon.Line, { name: "icon-times", onClick: onClick })))));
};
exports.default = GrowlMessage;
//# sourceMappingURL=growl-message.js.map